/**
 * Servicio para gestión de cursos del profesor
 */

import { CursoProfesor } from "../../app/profesor/cursos/dto/cursos.dto";
import { apiClientWeb } from "../../lib/apiClientWeb";

export const cursosProfesorService = {
  /**
   * Obtiene todos los cursos asignados al profesor
   * No necesita profesorId - usa el token JWT para identificar al profesor
   */
  getCursos: async (): Promise<CursoProfesor[]> => {
    const response = await apiClientWeb.get(`/api/profesor/cursos`);
    return response.data.data; // Backend devuelve { success, data, total }
  },

  updateCurso: async (
    idCurso: number,
    data: {
      nombre?: string;
      anio?: number;
      anioEscolar?: string;
      vigente?: boolean;
    }
  ): Promise<{ success: boolean; data: CursoProfesor }> => {
    const response = await apiClientWeb.patch(
      `/api/profesor/cursos/${idCurso}`,
      data
    );
    return response.data;
  },

  deleteCurso: async (cursoId: number) => {
    const response = await apiClientWeb.delete(
      `/api/profesor/cursos/${cursoId}`
    );
    return response.data;
  },

  /**
   * Crea un nuevo curso
   */
  createCurso: async (data: {
    nombre: string;
    anio: number;
    anioEscolarId: number;
    vigente?: boolean;
  }): Promise<{ success: boolean; data: any }> => {
    const response = await apiClientWeb.post(
      `/api/profesor/cursos`,
      data
    );
    return response.data;
  },

  /**
   * Obtiene todos los años escolares disponibles
   */
  getAniosEscolares: async (): Promise<
    { idAnioEscolar: number; nombre: string; orden: number }[]
  > => {
    const response = await apiClientWeb.get(
      `/api/profesor/alumnos/opciones/anios-escolares`
    );
    return response.data.data;
  },
};
